// src/components/PdfMappingTab.tsx

import React, { useState, useCallback } from 'react';
import { FormDefinition, getAllQuestionIds } from '../../../../interfaces/dynamicForms/FormBuilder';
import PdfAnnotator from '../pdfAnnotator/PdfAnnotator';
import MappingEditor from '../pdfAnnotator/MappingEditor';
import { DiscoveredPdfField, PdfMappingDefinition } from '../../../../interfaces/dynamicForms/MappingTypes';

interface PdfMappingTabProps {
    formDefinition: FormDefinition;
    pdfMapping: PdfMappingDefinition;
    onMappingChange: (newMapping: PdfMappingDefinition) => void;
    allQuestionIds: string[];
    initialPdfFile: File | null; 
    onNewPdfUpload: (file: File) => void;
}

const PdfMappingTab: React.FC<PdfMappingTabProps> = ({ formDefinition, pdfMapping, onMappingChange, allQuestionIds, initialPdfFile, onNewPdfUpload }) => {
    const [discoveredPdfFields, setDiscoveredPdfFields] = useState<DiscoveredPdfField[]>([]);

    const handleDiscoveredFields = useCallback((fields: DiscoveredPdfField[]) => {
        setDiscoveredPdfFields(fields);
    }, []);

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="border bg-white rounded-lg shadow-md">
                <PdfAnnotator
                    initialFile={initialPdfFile}
                    onFieldsExtracted={handleDiscoveredFields}
                    onNewFileSelect={onNewPdfUpload}
                />
            </div>
            <div className="border bg-white rounded-lg shadow-md">
                <MappingEditor
                    discoveredPdfFields={discoveredPdfFields}
                    allQuestionIds={allQuestionIds}
                    currentMapping={pdfMapping}
                    onMappingChange={onMappingChange}
                    formDefinition={formDefinition}
                />
            </div>
        </div>
    );
};

export default PdfMappingTab;